import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  @Output() scrollTo = new EventEmitter<string>();
  @Input() sections: any = [];
  @Input() knowledgeSections: any = [];
  @Input() nextNavigatorControl: any;
  @Input() previousNavigatorControl: any;
  @Input() overviewTitle: any = '';

  constructor() {}

  ngOnInit(): void {}

  scrollToSection(section: string) {
    this.scrollTo.emit(section);
  }
}
